import React, { useEffect, useState } from 'react'
import Papa from 'papaparse'
import { Table, Alert } from 'antd'
import {
  fetchFileContent,
  getTerminationFileSummaryByPublicKey,
} from '../api/terminations-enrollment-platform-api-client'
import PageWrapper from 'enrollment-platform/PageWrapper'
import Page from 'layouts/Page'
import BreadcrumbNav from 'enrollment-platform/components/Breadcrumbs'
import { CENSUS_MANAGEMENT_PATH } from '../constants'

const FailedTerminationFileView = ({
  routeParams,
}: {
  routeParams: { importPublicKey: string }
}) => {
  const [rows, setRows] = useState<any[]>([])
  const [errorMessage, setErrorMessage] = useState<string>('')
  const [fileName, setFileName] = useState('')

  useEffect(() => {
    const fetchAndParse = async () => {
      try {
        const { fileName, csvText } = await fetchFileContent(
          routeParams.importPublicKey
        )
        const parsed = Papa.parse(csvText, { header: true })
        setRows(parsed.data)
        setFileName(fileName)

        // Optional: if you have errors attached to rows in the API
        const summary = await getTerminationFileSummaryByPublicKey(
          routeParams.importPublicKey
        )
        setErrorMessage(summary.errors || 'An unknown error occurred.')
      } catch (e) {
        console.error('Failed to load failed file', e)
      }
    }

    fetchAndParse()
  }, [routeParams.importPublicKey])

  const columns = Object.keys(rows[0] || {}).map((key) => ({
    title: key,
    dataIndex: key,
    key,
  }))

  return (
    <PageWrapper>
      <Page
        title="Failed File"
        breadcrumb={
          <BreadcrumbNav
            items={[
              {
                title: 'Bulk Terminations',
                path: `${CENSUS_MANAGEMENT_PATH}/bulk-terminations`,
              },
              { title: `Failed Termination File ${fileName}` },
            ]}
          />
        }
      >
        {errorMessage && (
          <Alert
            type="error"
            message="File Processing Error"
            description={errorMessage}
            showIcon
            style={{ marginBottom: 16 }}
          />
        )}
        <Table
          dataSource={rows.map((r, idx) => ({
            ...r,
            key: idx,
          }))}
          columns={columns}
          pagination={false}
        />
      </Page>
    </PageWrapper>
  )
}

export default FailedTerminationFileView
